var React = require('react');

function Description (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"width":"13","height":"2.5","rx":"1.25","key":0}),React.createElement("rect",{"width":"18","height":"2.5","y":"4","rx":"1.25","key":1}),React.createElement("rect",{"width":"10","height":"2.5","y":"8","rx":"1.25","key":2}),React.createElement("rect",{"width":"14","height":"2.5","y":"12","rx":"1.25","key":3})]));
}

Description.defaultProps = {"width":"18","height":"15","viewBox":"0 0 18 15"};

module.exports = Description;

Description.default = Description;
